/*
Use this parameter to define the type of icon URL for a given place or category. Place icons are available in the following formats:

    svg
    cim (Cartographic Information Model)
    png 48 x 48 pixels
*/

export enum IconOptions {
  PNG = "png",
  SVG = "svg",
  CIM = "cim"
}
